module.exports = __webpack_public_path__ + "static/hero-lauv2-105b797e5747a6a4b92ce9e6cb173d3c.jpg";